import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase';
import Login from './Login';

export default function AuthGate({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    return onAuthStateChanged(auth, setUser);
  }, []);

  if (user === undefined) {
    return <p className="loading">Loading...</p>;
  }

  if (user === null) {
    return <Login />;
  }

  return (
    <div className="authenticated-shell">
      <div className="auth-bar">
        <span>Signed in as {user.email}</span>
        <button className="btn-secondary" onClick={() => signOut(auth)}>Sign out</button>
      </div>
      {children}
    </div>
  );
}
